<template>
  <v-app>
    <header-comp @event-category-changed="handleEventCategory" />
    <v-main class="main-content">
      <!-- Background Layer -->
      <div class="background-layer" v-if="selectedCategoryId != 0"
        :style="{ backgroundImage: `url(${backgroundImage})` }">
      </div>

      <!-- Logo Background Case (id=0) -->
      <div v-else class="background-layer logo-layer">
        <img :src="backgroundImage" alt="logo background" />
      </div>

      <!-- Foreground Content -->
      <div class="content-layer">
        <router-view @zip-code-changed="handleZipCodeChange" @event-category-changed="handleEventCategory" />
      </div>
    </v-main>
    <footer-comp :zip="zipCode" />
    <!-- Install / Open App Prompt Component -->
    <app-install-prompt />
  </v-app>
</template>

<script>
  import HeaderComp from './components/header-comp';
  import FooterComp from './components/footer-comp';
  //Import install prompt component
  import AppInstallPrompt from './components/app-install/AppInstallPrompt.vue';

  export default {
    name: 'App',
    data() {
      return {
        zipCode: localStorage.getItem('zip') || '',
        selectedCategoryId: parseInt(localStorage.getItem("event-category")) || 0,
        backgroundMap: {
          8: require('@/assets/images/bg/agriculture-bg.jpg'),
          5: require('@/assets/images/bg/art-bg.jpg'),
          7: require('@/assets/images/bg/boat-bg.jpg'),
          1: require('@/assets/images/bg/vehicles.png'),
          6: require('@/assets/images/bg/festivals-bg.jpg'),
          3: require('@/assets/images/bg/firearms-bg.jpg'),
          4: require('@/assets/images/bg/home-bg.jpg'),
          //4: require('@/assets/images/bg/brand-logo2_3.png'),
          9: require('@/assets/images/bg/misc-bg.jpg'),
          2: require('@/assets/images/bg/rv-bg.jpg'),
          0: require('@/assets/images/bg/brand-logo2_3.png'),
          //0: require('@/assets/images/bg/vehicles.png'),
        }
      };
    },
    components: {
      HeaderComp,
      FooterComp,
      AppInstallPrompt
    },
    methods: {
      handleZipCodeChange(newZipCode) {
        this.zipCode = newZipCode;
      },
      handleEventCategory(categoryId) {
        this.selectedCategoryId = categoryId;
      }
    },
    computed: {
      backgroundImage() {
        return this.backgroundMap[this.selectedCategoryId];
      },
      canonicalUrl() {
        const BASE = 'https://www.showusshows.com';
        const { path, query } = this.$route;

        // Keep ?id= only for event-detail (unique pages)
        if (path === '/event-detail' && query && query.id) {
          return `${BASE}${path}?id=${encodeURIComponent(query.id)}`;
        }

        // Normalize trailing slash (keep "/" only for homepage)
        const normalizedPath =
          path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path;

        return `${BASE}${normalizedPath}`;
      },

      robotsContent() {
        // Read per-route robots setting; default to index, follow
        return this.$route.meta && this.$route.meta.robots
          ? this.$route.meta.robots
          : 'index, follow';
      },
    },
    metaInfo() {
      return {
        link: [
          { rel: 'canonical', href: this.canonicalUrl }
        ],
        meta: [
          { name: 'robots', content: this.robotsContent }
        ]
      };
    },
  };
</script>

<style scoped>
  .main-content {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
  }

  /* Normal background (categories) */
  .background-layer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-attachment: fixed;
    z-index: 0;
  }

  /* Logo background (id=0) */
  .logo-layer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .logo-layer img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    filter: blur(2px);
  }

  /* Foreground */
  .content-layer {
    position: relative;
    z-index: 1;
    padding: 20px;
  }
</style>